export const SET_PEDIDOS = "pedidos/SET_PEDIDOS";
export const SET_PEDIDO = "pedidos/SET_PEDIDO";
export const SET_PAGINATION = "pedidos/SET_PAGINATION";
export const SET_ERROR = "pedidos/SET_ERROR";
